import React from "react";
import { motion } from "framer-motion";
import { IconBrandWhatsapp } from "@tabler/icons-react";

const WhatsAppWidget = () => {
  const phoneNumber = "+918850227415";
  const message = "Hi! I'm interested in your wellness services.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      style={{
        position: "fixed",
        bottom: "32px",
        right: "32px",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      className="w-14 h-14 bg-green-500/40 backdrop-blur-md border border-white/20 text-white rounded-full shadow-xl hover:bg-green-500/60 transition-all"
      aria-label="Chat on WhatsApp"
    >
      <IconBrandWhatsapp size={32} stroke={2} />
    </motion.a>
  );
};

export default WhatsAppWidget;
